import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var PlaneIcon = function PlaneIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "PlaneIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.421 1.563a.73.73 0 0 1 .58-.288h2c.26 0 .5.14.629.365l2.457 4.302h2.246a2.059 2.059 0 0 1 0 4.116h-2.245L8.63 14.36a.73.73 0 0 1-.63.365H6a.725.725 0 0 1-.697-.924l1.07-3.743H4.966l-1.12 1.121a.73.73 0 0 1-.514.213h-2a.725.725 0 0 1-.648-1.05L1.856 8 .685 5.658a.725.725 0 0 1 .648-1.05h2c.193 0 .377.077.513.213l1.121 1.12h1.405L5.303 2.2a.73.73 0 0 1 .118-.636m1.54 1.162 1.07 3.743a.725.725 0 0 1-.698.924H4.667a.73.73 0 0 1-.513-.213l-1.12-1.12h-.528l.81 1.617a.73.73 0 0 1 0 .648l-.81 1.618h.527L4.154 8.82a.73.73 0 0 1 .513-.213h2.666a.725.725 0 0 1 .697.925l-1.069 3.742h.618l2.458-4.301a.73.73 0 0 1 .63-.366h2.666a.609.609 0 0 0 0-1.216h-2.666c-.26 0-.5-.14-.63-.366L7.58 2.725z",
      clipRule: "evenodd"
    })
  }));
};

export { PlaneIcon };
